// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import global from "./global.json";
import auth from "./auth.json";
import breadcrumb from "./breadcrumb.json";
import dashboard from "./dashboard.json";
import news from "./news.json";
import newsTheme from "./newsTheme.json";
import keyword from "./keyword.json";
import menu from "./menu.json";
import settings from "./settings.json";
import template from "./template.json";
import surveys from "./surveys.json";
import usersManagement from "./usersManagement.json";
import profiles from "./profiles.json";
import statistics from "./statistics.json";
import broadcastList from "./broadcastList.json";
import thematicDossier from "./thematicDossier.json";
import missingUser from "./missingUsers.json";

const translationFR = {
  ...global,
  ...auth,
  ...breadcrumb,
  ...dashboard,
  ...news,
  ...newsTheme,
  ...keyword,
  ...settings,
  ...menu,
  ...template,
  ...surveys,
  ...usersManagement,
  ...profiles,
  ...statistics,
  ...broadcastList,
  ...thematicDossier,
  ...missingUser
};

export default translationFR;
